"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remoteVectorImageFormatExtensions = exports.remoteVectorSets = void 0;
exports.remoteVectorSets = ["icons-fallback", "icons-streamline", "illustrations-messaging", "images-brand", "images-fallback", "images-genius", "images-transport"];
exports.remoteVectorImageFormatExtensions = ["svg", "xml"];
